import Vue from "vue";

export const dialogState = Vue.observable({
  visible: false,
  type: "alert",
  title: "提示",
  message: "",
  value: "",
  placeholder: "",
  // 选择型弹窗（例如“善良阵营胜利/邪恶阵营胜利”）；其它类型保持为空数组，
  // 因此不会影响现有 alert / confirm / prompt 的渲染。
  choices: [],
  checkboxLabel: "",
  checked: false,
});

let complete;

function open(type, options = {}) {
  if (complete) complete(type === "confirm" ? false : null);
  dialogState.type = type;
  dialogState.title = options.title || "提示";
  dialogState.message = options.message || "";
    dialogState.value = options.value || "";
    dialogState.placeholder = options.placeholder || "";
    dialogState.choices = Array.isArray(options.choices) ? options.choices : [];
    dialogState.checkboxLabel = options.checkboxLabel || "";
    dialogState.checked = false;
    dialogState.visible = true;
  return new Promise((resolve) => {
    complete = resolve;
  });
}

export const dialog = {
  alert(message, title = "提示") {
    return open("alert", { title, message });
  },
  confirm(message, title = "请确认") {
    return open("confirm", { title, message });
  },
  confirmWithCheckbox(message, title, checkboxLabel) {
    return open("confirmCheckbox", { message, title, checkboxLabel });
  },
  prompt(title, options = {}) {
    return open("prompt", { title, ...options });
  },
  /**
   * 多选一弹窗。choices: [{ value, label }]，返回被选项的 value；
   * 点取消返回 null。现有弹窗行为完全不变，只是多了一种类型。
   */
  choose(title, options = {}) {
    return open("choose", { title, ...options });
  },
  close(value = null) {
    dialogState.visible = false;
    if (complete) complete(value);
    complete = null;
  },
};
